import React, { useEffect } from "react";
import "./HoppersRestaurantHomePage.scss"
import HoppersRestaurantHeroPage from "./HoppersRestaurantHeroPage";
import HoppersRestaurantServicePage from "./HoppersRestaurantServicePage";
import HoppersRestaurantMenuPage from "./HoppersRestaurantMenuPage";
import HoppersRestaurantGalleryPage from "./HoppersRestaurantGalleryPage";
import HoppersRestaurantReviewPage from "./HopperRestaurantReviewPage";
import HoppersRestaurantNumberPage from "./HopperRestaurantNumberPage";
import HoppersRestaurantSubscriptionPage from "./HopperRestaurantSubscriptionPage";
import HopperRestaurantAboutusPage from "./HopperRestaurantAboutusPage";
import { sortByOrderAscending } from "../../helper/helper";
import HopperRestaurantSpecials from "./HopperRestaurantSpecials";
import { useSelector } from "react-redux";
const HoppersRestaurantHomePage = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "homeRestaurant")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantHeroPage":
                return <HoppersRestaurantHeroPage components={component.Components} heroBackground={component?.Props?.bgSrc} />
            case "HopperRestaurantSpecials":
                return <HopperRestaurantSpecials components={component.Components} />
            case "HopperRestaurantAboutusPage":
                return <HopperRestaurantAboutusPage components={component.Components} />
            case "HoppersRestaurantServicePage":
                return <HoppersRestaurantServicePage components={component.Components} />
            case "HoppersRestaurantMenuPage":
                return <HoppersRestaurantMenuPage components={component.Components} />
            case "HoppersRestaurantGalleryPage":
                return <HoppersRestaurantGalleryPage components={component.Components} />
            case "HoppersRestaurantReviewPage":
                return <HoppersRestaurantReviewPage components={component.Components} />
            case "HoppersRestaurantNumberPage":
                return <HoppersRestaurantNumberPage components={component.Components} />
            case "HoppersRestaurantSubscriptionPage":
                return <HoppersRestaurantSubscriptionPage components={component.Components} background={component?.Props?.bgSrc} message={component?.Props?.successMessage} />
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersRestaurantHomePage">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )

}
export default HoppersRestaurantHomePage